import {Component, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {EditorModule} from 'primeng/editor';

@Component({
  selector: 'elcia-editor',
  imports: [ReactiveFormsModule, EditorModule],
  templateUrl: './editor.html',
  styleUrl: './editor.scss',
})

export class Editor {
  control = input.required<FormControl<string | null>>();
  styles = input<Record<string, string | number>>({
    height: '200px'
  });
}
